"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var FlagNP = function FlagNP(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "411.6",
    height: "270.36",
    viewBox: "0 0 411.6 270.36"
  }, props), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M209.54,146.36H-185.94A7.07,7.07,0,0,1-193,139.3V-114.94a7.06,7.06,0,0,1,7.06-7.06H209.54a7.06,7.06,0,0,1,7.06,7.06V139.3a7.06,7.06,0,0,1-7.06,7.06Zm0,0",
    transform: "translate(194 123)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-183.82-103.92-37.51,3H-150.25l13.73,15.31L-29.95,137.18H-183.82v-241.1m-6.72-16.28a7,7,0,0,0-2.46,5.26V139.3a7.07,7.07,0,0,0,7.06,7.06H-9.39L-129.68,12.18H-9.39Zm0,0",
    transform: "translate(194 123)",
    fill: "#41479b"
  }), /*#__PURE__*/_react["default"].createElement("polyline", {
    points: "10.18 19.08 156.49 126 43.75 126 57.48 141.31 164.06 260.18 10.18 260.18 10.18 19.08",
    fill: "#ff4b55"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-139.13,44.5l5.66,11.66,10.73-7.27a.68.68,0,0,1,1.06.61l-.93,12.93,12.93-.93a.68.68,0,0,1,.61,1.06l-7.27,10.73L-104.68,79a.68.68,0,0,1,0,1.23l-11.66,5.65,7.27,10.73a.68.68,0,0,1-.61,1.06l-12.93-.93.93,12.93a.67.67,0,0,1-1.06.61L-133.47,103l-5.66,11.66a.68.68,0,0,1-1.23,0L-146,103l-10.73,7.27a.67.67,0,0,1-1.06-.61l.93-12.93-12.93.93a.68.68,0,0,1-.61-1.06l7.27-10.73-11.67-5.65a.69.69,0,0,1,0-1.23l11.67-5.65-7.27-10.73a.68.68,0,0,1,.61-1.07l12.93.94-.94-12.93a.69.69,0,0,1,1.07-.62L-146,56.17l5.65-11.67a.68.68,0,0,1,1.23,0Zm0,0",
    transform: "translate(194 123)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-124.45-23l-4.9-3.35,4.32-4.53L-131.19-32l2.1-5.89-6.08,1.47-.47-6.23-5,3.82-3-5.51-3,5.51-5-3.82-.48,6.24L-158-37.87l2.1,5.89-6.15,1.13,4.32,4.53L-162.69-23a45.47,45.47,0,0,1-15.92-12.34,35.57,35.57,0,0,0,35,29.54,35.58,35.58,0,0,0,35.05-29.54A45.51,45.51,0,0,1-124.45-23Zm0,0",
    transform: "translate(194 123)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/_react["default"].createElement("rect", {
    x: "1",
    y: "1",
    width: "409.6",
    height: "268.36",
    rx: "7",
    ry: "7",
    fill: "none"
  }));
};

var _default = FlagNP;
exports["default"] = _default;